import axios from "axios";
import { API_URL } from "../constants/environment";
import { logout, refreshUser } from "@/stores/authStore";

export const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.defaults.headers.common["Content-Type"] = "application/json";

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== "/auth/signin"
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({
            resolve: (token: string) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axios(originalRequest));
            },
            reject: (err: any) => {
              reject(err);
            },
          });
        });
      }
      originalRequest._retry = true;
      isRefreshing = true;
      const refreshToken = localStorage.getItem("RefreshToken");
      if (refreshToken && refreshToken !== "null") {
        try {
          const response = await axios.post(`auth/refresh-token`, {
            refreshToken,
          });
          const newAccessToken = response.data.accessToken;
          localStorage.setItem("AccessToken", newAccessToken);
          axiosApi.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          processQueue(null, newAccessToken);
          isRefreshing = false;
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          refreshUser();
          return axios(originalRequest);
        } catch (err) {
          processQueue(err, null);
          isRefreshing = false;
          logout();
          return Promise.reject(err);
        }
      } else {
        isRefreshing = false;
        logout();
      }
    }
    return Promise.reject(error);
  },
);

axiosApi.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("AccessToken")?.replace(/^"|"$/g, "");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
